<div class="flex flex-row justify-between pb-10">
  <div class="flex flex-col mb-10">
    <div class="mat-headline fw-700 fs-22 mt-20  ml-20">{{'INSTANCE_SUMMARY.UPDATE_MENU.REQUEST_UPDATE_RELEASE_PACKAGE' | transloco}}
    </div>
  </div>
  <mat-icon svgIcon="close" class="close-icon mr-10 mt-20" (click)="verifyFormCancel()"></mat-icon>
</div>
<mat-divider class="mb-10 neutral-2 ml-20 mr-20"></mat-divider>
<div class="mat-subheading-2 fw-500 fs-16 ml-20 mt-20">{{'INSTANCE_SUMMARY.UPDATE_MENU.PROD_UPDATED_BASEDON_SELECTION' |
  transloco}}</div>
<div class="flex items-center tbl-cell col-select user-select-none">
  <div class="flex flex-row mt-10">
    <mat-icon [svgIcon]="!onVerifyClickButton ? 'radio_button_unchecked' : 'radio_button_checked'"
      (click)="onVerifyClick()" class="radio-icon cursor-pointer mb-14 ml-20 mt-10"></mat-icon>
    <div class="mat-subheading-2 fw-700 fs-16  ml-1 mt-10">{{'INSTANCE_SUMMARY.UPDATE_MENU.VERIFY_UPDATE'| transloco}}</div>
  </div>

  <div class="flex flex-row mt-10 ">
    <mat-icon [svgIcon]="!onApplyClickButton ? 'radio_button_unchecked' : 'radio_button_checked'"
      (click)="onApplyClick()" class="radio-icon cursor-pointer mb-14 ml-20 mt-10"></mat-icon>
    <div class="mat-subheading-2 fw-700 fs-16 ml-1 mt-10">{{'INSTANCE_SUMMARY.UPDATE_MENU.WITHOUT_VERIFYING_UPDATE' |
      transloco}}</div>
  </div>

</div>
<div class="flex flex-row ml-20" *ngIf="onVerifyClickButton">{{'INSTANCE_SUMMARY.UPDATE_MENU.VERIFY_UPDATE_TEXT'| transloco}}</div>
<div class="flex flex-row ml-20" *ngIf="onApplyClickButton">{{'INSTANCE_SUMMARY.UPDATE_MENU.WITHOUT_VERIFY_TEXT'| transloco}}</div>
<div class="flex flex-row justify-end items-center mt-100">
  <button class="white mr-20 mb-20 report-letter-spacing" type="button" (click)="verifyFormCancel()"> {{ 'BUTTONS.CANCEL' |
    transloco }} </button>
  <button [ngClass]="{'disabled': !onApplyClickButton && !onVerifyClickButton}" class="error-report-bg-color accent report-letter-spacing mr-20 mb-20" type="button" (click)="verifyForm()"> {{
    'BUTTONS.SUBMIT' | transloco }}</button>
</div>